import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent implements OnInit {

  @Input() errorMessage: string;
  @Input() longErrorMessage: string;

  constructor(public activeModal: NgbActiveModal) {
    this.errorMessage = '';
    this.longErrorMessage = '';
  }

  ngOnInit() {
  }

}
